module.exports = __webpack_public_path__ + "img/RJMT_telephone.6963b0bd.svg";